import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import { layout } from "./models/LayoutSale";
import { useLayout } from "hooks/layout";

// import LayoutSale

function RestOrderTabs() {
  const _layout = useLayout(layout);
  const currentView = useSignal("column");

  return <Board layout={_layout} currentView={currentView} />;
}

export default RestOrderTabs;
